import React from 'react';
import { classNames } from '~/utils/classNames';
import FigmaIcon from '~/components/ui/Icons/FigmaIcon';

interface FigmaAttachmentPreviewProps {
  fileName?: string;
  onRemove: () => void;
}

export const FigmaAttachmentPreview: React.FC<FigmaAttachmentPreviewProps> = ({
  fileName = 'Figma.File',
  onRemove,
}) => {
  return (
    <div
      className={classNames(
        'relative inline-flex items-center gap-3 pl-3 pr-10 py-3 rounded-xl min-w-[180px]',
        'bg-dualite-background-button',
      )}
    >
      {/* Figma Logo */}
      <div
        className={classNames('flex items-center justify-center w-10 h-10 rounded-lg', 'bg-dualite-background-button')}
      >
        <FigmaIcon size={20} />
      </div>

      {/* File Info */}
      <div className="flex flex-col min-w-0">
        <span className="text-sm font-medium text-dualite-text-primary truncate">{fileName}</span>
        <span className="text-xs text-dualite-text-tertiary mt-2">Figma</span>
      </div>

      <button
        onClick={(e) => {
          e.stopPropagation();
          onRemove();
        }}
        className={classNames(
          'absolute top-2 right-2',
          'flex items-center justify-center w-5 h-5 rounded-full',
          'bg-dualite-background-button hover:bg-dualite-background-buttonHover',
          'transition-colors duration-150',
        )}
        aria-label="Remove Figma attachment"
      >
        <div className="i-ph:x text-xs text-dualite-text-dismissIcon" />
      </button>
    </div>
  );
};
